import * as yup from 'yup';

export const addExternalCustomerFormValidator = yup.object().shape({
  email: yup.string().email().required('customer.inviteModal.emailError'),
  firstName: yup.string().required('customer.inviteModal.firstNameError'),
  lastName: yup.string().required('customer.inviteModal.lastNameError'),
});
